import React, { useEffect, useState } from "react";
import { getCurrentChild } from "src/shared/redux-state/src";
import { fetchDailyDiaryDetails } from "src/shared/services/src";
import { ChildrenStoreData, DailyDiary } from "src/shared/types/src";
import { useAppDispatch, useAppSelector } from "../../services/store";
import { AxiosError } from "axios";
import { TimelineActions } from "src/shared/redux-state/src/lib/timeline/TimelineSlice";
import { dateFormatter } from "src/shared/utils/src";
import { APP_MESSAGES, DATE_FORMATS } from "src/shared/config/src";
import ProfileLayout from "src/app/layouts/ProfileLayout";
import { toast } from "react-toastify";
import { DailyDiaryDetails, DailyDiaryLoader } from "src/app/components";
import { URL_CONSTANTS } from "src/app/config/appConstants";
import { useLocation } from "react-router-dom";

const DailyDiaryDetailsScreen = () => {

    const location = useLocation();
    const dispatch = useAppDispatch();
    const [fetchDate, setFetchDate] = useState<string>();
    const [dailyDiaryLoading, setDailyDiaryLoading] = useState<boolean>(false);
    const [dailyDiaryDetails, setDailyDiaryDetails] = useState<DailyDiary>();

    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    useEffect(() => {
        (async () => {
            const { dailyDiaryDetails } = location.state ? location.state as Readonly<{ dailyDiaryDetails: DailyDiary }> : {};
            if (dailyDiaryDetails){
                setDailyDiaryDetails(dailyDiaryDetails);
            } else {
                const searchParams = new URLSearchParams(window.location.search.slice(1));
                const date: any = searchParams.get(URL_CONSTANTS.DATE) ? searchParams.get(URL_CONSTANTS.DATE) : ''
                setFetchDate(date);
                (async () => {
                    await getDailyDiaryDetails(date);
                })();
            }
        })();
    }, [location.state, location?.state?.dailyDiaryDetails]);

    const getDailyDiaryDetails = async (date: string) => {
        if (!date) {
            return;
        }
        try {
            setDailyDiaryLoading(true);
            const response = await fetchDailyDiaryDetails({ child: currentChild, date });
            if (response && Object.keys(response).length) {
                setDailyDiaryDetails(response.dailyDiary);
                await dispatch(TimelineActions.updateDailyDiaryDetailsInTimeline({ diary: response.dailyDiary, date }));
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                const apiError = error as AxiosError;
                if (apiError && apiError.response) {
                    const backendErrors = error.response?.data;
                    const {errors} = backendErrors;
                    toast.error(errors.join(", "), { autoClose: 5000 });
                } else {
                    toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
                }
            } else {
                toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
            }
        } finally {
            setDailyDiaryLoading(false);
        }
    }

    const renderNoData = () => {
        return (
            <div>
                <p>No data available</p>
            </div>
        )
    }

    return (
        <ProfileLayout title={`Diary for ${dateFormatter(fetchDate ? fetchDate : new Date(), DATE_FORMATS.SHORT_DATE)}`} fixedFooter={true} isPrintPage={true} handlePrint={() => window.print()}>
            {dailyDiaryLoading ?
                <DailyDiaryLoader /> :
                <div>
                    {
                        (dailyDiaryDetails && Object.keys(dailyDiaryDetails).length > 0) ? 
                        <DailyDiaryDetails details={dailyDiaryDetails} /> : renderNoData()
                    }
                </div>
            }
        </ProfileLayout>

    )
}

export default DailyDiaryDetailsScreen;